var map = {
	"./Banjo.png": "e780",
	"./Bass Drum.png": "0d89",
	"./Bell.png": "0e13",
	"./Bit.png": "21d4",
	"./Chime.png": "0530",
	"./Click.png": "9930",
	"./Cow Bell.png": "94e6",
	"./Didgeridoo.png": "fc3f",
	"./Double Bass.png": "da83",
	"./Flute.png": "1601",
	"./Guitar.png": "9876",
	"./Harp.png": "1fa89",
	"./Iron Xylophone.png": "fde9",
	"./Pling.png": "ef4f",
	"./Snare Drum.png": "73b1",
	"./Xylophone.png": "5ca3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ab9";